import { Injectable,Component } from '@angular/core';
import { HttpHeaders}  from '@angular/common/http';  
import { Observable,throwError  } from 'rxjs';  
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible:boolean;
};
export class Physicaldisability {
  PhysicalDisabilityID: number;
  PhysicalDisabilityName: string;
  PhysicalDisabilityShortName: string;
  PhysicalDisabilityCode: string;
  CreatedLoginID:number;
  UpdatedLoginID:number;  
  IsDefault:number;
} 

let gridColumns: GridColumns[] = [
{
  "caption": 'Name',
  "dataField": "PhysicalDisabilityName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Short Name',
  "dataField": "PhysicalDisabilityShortName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
{
  "caption": 'Code',
  "dataField": "PhysicalDisabilityCode",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true,
  "visible":true
},
];
@Injectable(
  {  
    providedIn: 'root'  
  }
) 
export class PhysicaldisabilityService {
  constructor(
    private dataService: DataAccessService) {
  }
  public PhysicaldisabilityData: Physicaldisability;
  public errormsg;
  public successmsg;
  public getAllPhysicaldisability() {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'GetBasicPhysicalDisabilityList?PhysicalDisabilityID=0'; // setting method name from API controller.
    return this.dataService.getAll<Physicaldisability[]>()
  } 
  public getPhysicalDisabilityByID() {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'GetBasicPhysicalDisabilityList';
    this.dataService
      .getSingle<Physicaldisability>('?PhysicalDisabilityID=0')    
      .subscribe((data: Physicaldisability) => this.PhysicaldisabilityData = data,
        error => () => {
        },
        () => {
              return this.PhysicaldisabilityData;
        });
  }
  public save(data) {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'PostInsertBasicPhysicalDisability'; // setting method name from API controller.
    return this.dataService.add<Physicaldisability[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'PostBasicPhysicalDisability'; // setting method name from API controller.
    return this.dataService.add<Physicaldisability[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'PostDeleteBasicPhysicalDisability'; // setting method name from API controller.
    return this.dataService.delete<Physicaldisability[]>(data)
  }
  getGridColumnsData() {
    return Physicaldisability[0];
  }
  getGridColumns() {
    return gridColumns;
  }


  public GetBasicPhysicalDisabilityListForStudentProfile() {
    this.dataService.setControllerName = '/BasicPhysicalDisability/';
    this.dataService.setMethodName = 'GetBasicPhysicalDisabilityListForStudentProfile?PhysicalDisabilityID=0'; // setting method name from API controller.
    return this.dataService.getAll<Physicaldisability[]>()
  } 
}  
 